import React, { useEffect, useRef, useState } from 'react'
import './kubernetesConfigurations.css'
import SubNavbar from '../../../components/SubNavbar/SubNavbar'
import { get_cluster_status } from '../functions';
import ExitButton from '../../../components/buttons/exit/ExitButton';
import KubernetesConfigurationsOverview from './pages/overview/overview';
import KubernetesConfigurationsIstio from './pages/istio/istio';


function KubernetesConfigurations({connector, exitWindow}) {

    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState("overview")
    const [clusterStatus, setClusterStatus] = useState(false);
    const [stopPolling, setStopPolling] = useState(false)
    
    const intervalRef = useRef(null);

    

    const exit = () => {
        setStopPolling(true)
        exitWindow();
    }

  useEffect(() => {
    if (stopPolling) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    intervalRef.current = setInterval(() => {
      get_cluster_status(`cluster-${String(connector.connector_id)}`, setClusterStatus)
      // fetchStatus()
    }, 2000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [stopPolling]);
    
    useEffect(()=>{setLoading(false)}, [clusterStatus])
    // useEffect(()=>get_cluster_status("cluster-abc123", setClusterStatus), [])


    return (
        <div className='kuberentes-configurations shadow-glow '>
            <SubNavbar options={!clusterStatus ? ["overview"] : [
                    "overview",
                    "istio",
                    "resources",
                    "storage"
                ]} setPage={setCurrentPage}/>
            <div className='page'>
            <ExitButton onClick={exit}/>
            {
                currentPage === "overview" && 
                <KubernetesConfigurationsOverview connector={connector} clusterStatus={clusterStatus}/>
            }
            {
              currentPage === "istio" &&
              // <label>kakkak</label>
              <KubernetesConfigurationsIstio connectorId={connector.connector_id}/>
            }
            </div>
            
        </div>
    )
}

export default KubernetesConfigurations